import { Input } from "@/components/ui/input";

export function InventoryAddresses({ form, setForm, isEditable }) {
  return (
    <div className="card-surface p-4 sm:p-5 space-y-4">
      <h2 className="text-sm font-semibold font-['Outfit'] text-zinc-500 uppercase tracking-wider">Indirizzi</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
        <div className="space-y-2.5">
          <p className="text-xs font-semibold text-zinc-700">Ritiro</p>
          <Input placeholder="Indirizzo *" value={form.pickup_address} onChange={(e) => setForm({ ...form, pickup_address: e.target.value })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" required />
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
            <Input placeholder="Città *" value={form.pickup_city} onChange={(e) => setForm({ ...form, pickup_city: e.target.value })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm sm:col-span-1" required />
            <div className="grid grid-cols-2 gap-2 sm:contents">
              <Input placeholder="Prov. *" value={form.pickup_province} onChange={(e) => setForm({ ...form, pickup_province: e.target.value.toUpperCase().slice(0, 2) })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" maxLength={2} required />
              <Input inputMode="numeric" placeholder="CAP *" value={form.pickup_cap} onChange={(e) => setForm({ ...form, pickup_cap: e.target.value })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" maxLength={5} required />
            </div>
          </div>
        </div>
        <div className="space-y-2.5">
          <p className="text-xs font-semibold text-zinc-700">{form.delivery_type === "deposito" ? "Scarico (Deposito Magazzino)" : "Consegna"}</p>
          {form.delivery_type === "deposito" ? (
            <div className="flex items-center gap-3 p-4 bg-amber-50 border border-amber-200 rounded-sm">
              <p className="text-sm text-amber-700">Deposito in magazzino aziendale</p>
            </div>
          ) : (
            <>
              <Input placeholder="Indirizzo *" value={form.delivery_address} onChange={(e) => setForm({ ...form, delivery_address: e.target.value })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" required />
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                <Input placeholder="Città *" value={form.delivery_city} onChange={(e) => setForm({ ...form, delivery_city: e.target.value })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" required />
                <div className="grid grid-cols-2 gap-2 sm:contents">
                  <Input placeholder="Prov. *" value={form.delivery_province} onChange={(e) => setForm({ ...form, delivery_province: e.target.value.toUpperCase().slice(0, 2) })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" maxLength={2} required />
                  <Input inputMode="numeric" placeholder="CAP *" value={form.delivery_cap} onChange={(e) => setForm({ ...form, delivery_cap: e.target.value })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" maxLength={5} required />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
